<div class="left-col">
  <div class="stats">
    <div class="time">
      
      <div>
        <label>In:</label
        ><span>{{
          getActiveSegment()
            ? formatCurrentSegmentTime(getActiveSegment().item.startsAtMs)
            : "--:--:--.---"
        }}</span>
      </div>
      <div>
        <label>Out:</label
        ><span>{{
          getActiveSegment()
            ? formatCurrentSegmentTime(getActiveSegment().item.endsAtMs)
            : "--:--:--.---"
        }}</span>
      </div>
    </div>
  </div>
  <div class="tracks-labels">
    <div>Event notification</div>
    <div>Video</div>
    <div>Audio</div>
    <div>Subtitles</div>
    <div>Graphics</div>
  </div>
</div>
<div class="right-col">
  <div
    #timeline
    class="timeline"
    (mousemove)="onMouseMove($event)"
    (mouseleave)="onMouseLeave()"
    (mousedown)="onTimelineMouseDown($event)"
  >
    <div class="timers" *ngIf="vm">
      <span>
      </span>
      <span>
      </span>
    </div>
    <div #playhead class="playhead">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 11"
        height="11"
        width="12"
        (mousedown)="onPlayheadMouseDown($event)"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0H12V6L6 10.5834L0 6V0Z"
          fill="black"
        />
      </svg>
      <svg
        class="playhead-line"
        [attr.height]="getPlayheadLineHeight()"
        width="1.5"
        xmlns="http://www.w3.org/2000/svg"
        shape-rendering="crispEdges"
        [attr.viewBox]="'0 0 1.5 ' + getPlayheadLineHeight()"
      >
        <rect
          width="1"
          [attr.height]="getPlayheadLineHeight()"
          fill="black"
          vector-effect="non-scaling-stroke"
        />
      </svg>
    </div>
    <div class="segments" #activeSegmentTrack>
      <evrideo-content-control-studio-timeline-segment
        *ngIf="selectedSegmentId"
        [segment]="getActiveSegment()?.item"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
        (on-drag-in-mark)="onInMarkMouseDown($event)"
        (on-drag-out-mark)="onOutMarkMouseDown($event)"
      ></evrideo-content-control-studio-timeline-segment>
      <evrideo-content-control-studio-timeline-inclusive-segment
        *ngFor="let inclusiveSegment of getInclusiveSegments(); trackBy: trackBySegment"
        [segment]="inclusiveSegment.item"
        [width]="pixelsPerSecond()"
        [style.left.px]="inclusiveSegment.left"
        [height]="getComponentHeight()"
      ></evrideo-content-control-studio-timeline-inclusive-segment>
    </div>
    <div
      class="tooltip"
      *ngIf="getShowTooltip()"
      [ngStyle]="{ 'top.px': getTooltipPosition().y, 'left.px': getTooltipPosition().x }"
    >
      {{ getTooltipFormattedCurrentTime() }}
    </div>
    <cdk-virtual-scroll-viewport
    #timelineVirtualScroll
      class="scroll-zone"
      [itemSize]="getTimelineBlockWidthPx()"
      orientation="horizontal"
    >
      <div
        *cdkVirtualFor="let timeBlock of getTimeBlocks(); trackBy: trackByTimeBlock"
        class="time-block"
        [style.width.px]="timeBlock.widthPx"
      >
        <div
          class="time-label-container"
          [style.left.px]="
            timeBlock.timestampLeftPx ? timeBlock.timestampLeftPx : ''
          "
        >
          <span class="time-label">
            {{
              isNaN(timeBlock.timestampMs)
                ? timeBlock.timestampMs
                : vm.timeFormatFunction(timeBlock.timestampMs)
            }}
          </span>
        </div>
        <svg [attr.width]="timeBlock.widthPx" height="37" class="block-svg">
          <g *ngFor="let tick of timeBlock.ticks; trackBy: trackByTickIndex">
            <line
              [attr.x1]="tick.xPx"
              [attr.y1]="tick.y1Px"
              [attr.x2]="tick.xPx"
              [attr.y2]="tick.y2Px"
              [attr.stroke-width]="tick.widthPx"
              stroke="#737E8C"
            ></line>
          </g>
        </svg>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <div
    #tracks
    class="tracks"
    (mousemove)="emptyEventAction($event)"
    (mouseleave)="emptyEventAction($event)"
    (mousedown)="emptyEventAction($event)"
  >
    <div #track>
      <evrideo-content-control-studio-timeline-track-segment
        *ngFor="let segment of getEventNotificationSegments(); trackBy: trackBySegment"
        [segment]="segment.item"
        [width]="segment.width"
        [style.left.px]="segment.left"
        (click)="changeSelectedSegment(segment.item.id)"
        (on-keyframe-click)="onKeyframeClicked($event)"
        [ngStyle]="segment.style"
      ></evrideo-content-control-studio-timeline-track-segment>
      <evrideo-content-control-studio-timeline-track-segment
        class="current-segment-shade"
        *ngIf="selectedSegmentId"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
      ></evrideo-content-control-studio-timeline-track-segment>
    </div>
    <div #track>
      <evrideo-content-control-studio-timeline-track-segment
        *ngFor="let segment of getVideoSegments(); trackBy: trackBySegment"
        [keyframes]="segment.keyframes"
        [segment]="segment.item"
        [width]="segment.width"
        [style.left.px]="segment.left"
        (click)="changeSelectedSegment(segment.item.id)"
        (on-keyframe-click)="onKeyframeClicked($event)"
        [ngStyle]="segment.style"
      ></evrideo-content-control-studio-timeline-track-segment>
      <evrideo-content-control-studio-timeline-track-segment
        class="current-segment-shade"
        *ngIf="selectedSegmentId"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
      ></evrideo-content-control-studio-timeline-track-segment>
    </div>
    <div #track>
      <evrideo-content-control-studio-timeline-track-segment
        *ngFor="let segment of getAudioSegments(); trackBy: trackBySegment"
        [segment]="segment.item"
        [width]="segment.width"
        [style.left.px]="segment.left"
        (click)="changeSelectedSegment(segment.item.id)"
        (on-keyframe-click)="onKeyframeClicked($event)"
        [ngStyle]="segment.style"
      ></evrideo-content-control-studio-timeline-track-segment>
      <evrideo-content-control-studio-timeline-track-segment
        class="current-segment-shade"
        *ngIf="selectedSegmentId"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
      ></evrideo-content-control-studio-timeline-track-segment>
    </div>
    <div #track>
      <evrideo-content-control-studio-timeline-track-segment
        *ngFor="let segment of getSubtitlesSegments(); trackBy: trackBySegment"
        [segment]="segment.item"
        [width]="segment.width"
        [style.left.px]="segment.left"
        (click)="changeSelectedSegment(segment.item.id)"
        (on-keyframe-click)="onKeyframeClicked($event)"
        [ngStyle]="segment.style"
      ></evrideo-content-control-studio-timeline-track-segment>
      <evrideo-content-control-studio-timeline-track-segment
        class="current-segment-shade"
        *ngIf="selectedSegmentId"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
      ></evrideo-content-control-studio-timeline-track-segment>
    </div>
    <div #track>
      <evrideo-content-control-studio-timeline-track-segment
        *ngFor="let segment of getGraphicsSegments(); trackBy: trackBySegment"
        [segment]="segment.item"
        [width]="segment.width"
        [style.left.px]="segment.left"
        (click)="changeSelectedSegment(segment.item.id)"
        (on-keyframe-click)="onKeyframeClicked($event)"
        [ngStyle]="segment.style"
      ></evrideo-content-control-studio-timeline-track-segment>
      <evrideo-content-control-studio-timeline-track-segment
        class="current-segment-shade"
        *ngIf="selectedSegmentId"
        [width]="getActiveSegment()?.width ?? 0"
        [style.left.px]="getActiveSegment()?.left"
      ></evrideo-content-control-studio-timeline-track-segment>
    </div>
  </div>
</div>
